<mat-nav-list>
    <a mat-list-item *ngFor="let option of options" (click)="SelectOption(option)">
        <ng-container *ngTemplateOutlet="option.content"></ng-container>
    </a>
</mat-nav-list>
